import { NavLink } from "react-router-dom";
import styles from "../styles/sidebar/RecentPosts.module.css";
import { paths } from "../../constants/paths";
import { normalizeBlogSlug, normalizePath } from "../../helpers/pathUtils";
import blogsData from "../../constants/blogsData";
import type { BlogPost } from "../../types/blog";

const RecentPosts = () => {
  // Get the 5 most recent posts (use created_at first, then fallback to date)
  const typedBlogsData = blogsData as unknown as BlogPost[];
  const recentPosts = [...typedBlogsData]
    .sort((a: BlogPost, b: BlogPost) => {
      const aVal = (a.created_at ?? a.date ?? 0) as string | number | Date;
      const bVal = (b.created_at ?? b.date ?? 0) as string | number | Date;
      const aDate = new Date(aVal).getTime();
      const bDate = new Date(bVal).getTime();
      return bDate - aDate;
    })
    .slice(0, 5);

  return (
    <div className={styles.recentPosts}>
      <h3 className={styles.recentTitle}>Recent Posts</h3>
      <div className={styles.postsList}>
        {recentPosts.map((post) => {
          const normalizedSlug = normalizeBlogSlug(post.slug || post.id);
          const postUrl = normalizePath(`${paths.blog}${normalizedSlug}`);
          return (
            <article key={post.id} className={styles.recentPost}>
              <div className={styles.postImage}>
                <NavLink to={postUrl}>
                {post?.featured_image ? (
                  <img
                    src={post?.featured_image}
                    alt={post.title}
                    loading="lazy"
                    className={styles.image}
                  />
                ) : (
                  <div className={styles.image} aria-hidden="true" />
                )}
              </NavLink>
            </div>
            <div className={styles.postContent}>
              <h3 className={styles.postTitle}>
                <NavLink
                  to={postUrl}
                  className={styles.postLink}
                >
                  {post.title}
                </NavLink>
              </h3>
            </div>
          </article>
        );
      })}
      </div>
    </div>
  );
};

export default RecentPosts;
